import { createApiSlice } from 'app/createApiSlice'
import {
  API_EVENT_PARTICIPANT,
  API_EVENT_PARTICIPANT_USERS,
} from 'utils/apiList'

export const eventParticipantApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'event-participant/hooks',
  endpoints(builder) {
    return {
      fetchEventParticipant: builder.query({
        query(params) {
          return {
            url: `${API_EVENT_PARTICIPANT}/${params?.id}`,
            params,
          }
        },
      }),
      fetchEventParticipantForForm: builder.query({
        query() {
          return `${API_EVENT_PARTICIPANT}?all=true`
        },
        transformResponse(response) {
          return response?.map((item) => ({
            value: item.id,
            label: item.name,
          }))
        },
      }),
      fetchUsersListEvent: builder.query({
        query(payload) {
          return {
            url: `${API_EVENT_PARTICIPANT_USERS}`,
            params: payload,
          }
        },
        transformResponse(response) {
          const newData = response?.items?.map((item) => ({
            value: item.userId,
            label: `${item.name} (${item?.phoneNumber})`,
          }))
          return { ...response, newData }
        },
      }),
      addEventParticipant: builder.mutation({
        query(payload) {
          return {
            url: API_EVENT_PARTICIPANT,
            method: 'POST',
            body: payload,
          }
        },
      }),
      editEventParticipant: builder.mutation({
        query(payload) {
          return {
            url: `${API_EVENT_PARTICIPANT}/${payload.id}`,
            method: 'PUT',
            body: payload,
          }
        },
      }),
      deleteEventParticipant: builder.mutation({
        query(payload) {
          return {
            url: `${API_EVENT_PARTICIPANT}/${payload.id}/events/${payload?.eventId}`,
            method: 'DELETE',
            body: payload,
          }
        },
      }),
    }
  },
})

export const {
  useFetchEventParticipantQuery,
  useFetchEventParticipantForFormQuery,
  useAddEventParticipantMutation,
  useEditEventParticipantMutation,
  useDeleteEventParticipantMutation,
  useFetchUsersListEventQuery,
  useLazyFetchUsersListEventQuery,
} = eventParticipantApiSlice
